import { render, staticRenderFns } from "./tabMBL2.vue?vue&type=template&id=2accf981&scoped=true&"
import script from "./tabMBL2.vue?vue&type=script&lang=js&"
export * from "./tabMBL2.vue?vue&type=script&lang=js&"
import style0 from "./tabMBL2.vue?vue&type=style&index=0&id=2accf981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2accf981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2accf981')) {
      api.createRecord('2accf981', component.options)
    } else {
      api.reload('2accf981', component.options)
    }
    module.hot.accept("./tabMBL2.vue?vue&type=template&id=2accf981&scoped=true&", function () {
      api.rerender('2accf981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabMBL2.vue"
export default component.exports